module.exports = __webpack_public_path__ + "static/media/no-img-available.ce45efbf.webp";